import gql from 'graphql-tag'

import { fragments as NodeFragments } from 'components/Node'

export const query = gql`
  query($path: String!) {
    route(path: $path) {
      ... on EntityCanonicalUrl {
        entity {
          entityId
          entityType

          ... on NodeArticle {
            ...NodeArticleFragment
          }
        }
      }
    }
  }

  ${NodeFragments.article}
`

export const queryLatest = gql`
  query($nid: String!, $revision: EntityQueryRevisionMode!) {
    nodeQuery(
      revisions: $revision
      filter: { conditions: [{ operator: EQUAL, field: "nid", value: [$nid] }] }
    ) {
      entities {
        ... on Node {
          entityId
          entityType

          ... on NodeArticle {
            ...NodeArticleFragment
          }
        }
      }
    }
  }

  ${NodeFragments.article}
`
